module.exports = __webpack_public_path__ + "static/img/partner4.700b23c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner4.png
// module id = esan
// module chunks = 1